<div class="bg-white rounded-lg shadow-md p-1 relative">
  <p-button
    (click)="onOpenAddDialogClick()"
    label="{{ 'dashboard.newAnimal' | transloco }}"
    icon="pi pi-plus"
    iconPos="left"
    styleClass="absolute top-2 right-2"
  />
  <h2 class="p-1 text-center text-xl font-semibold mb-5">
    {{ 'dashboard.search.headline' | transloco }}
  </h2>
  <div class="flex flex-row w-full justify-center mb-2 px-3">
    <div class="flex w-full max-w-2xl">
      <p-inputgroup>
        <input
          pInputText
          type="text"
          class="rounded-r-none! z-10"
          [(ngModel)]="searchTerm"
          (input)="onSearchInput()"
          placeholder="Suche nach Tier"
          spellcheck="false"
          autocomplete="off"
        />
        <p-inputgroup-addon class="ml-[-40px] z-20">
          <i class="pi pi-times" (click)="searchTerm=''; onSearchInput()" style="cursor: pointer;"
             *ngIf="searchTerm.length > 0"></i>
        </p-inputgroup-addon>
        <p-inputgroup-addon class="p-0">
          <p-button
            icon="pi pi-filter"
            (click)="toggleFilters()"
            [text]="true"
            class="h-[50px] w-[40px]"
            [outlined]="showFilters"
            [severity]="showFilters ? 'primary' : undefined"
            styleClass="rounded-none"
          />
        </p-inputgroup-addon>
        <p-inputgroup-addon>
          <p-button
            icon="pi pi-search"
            (click)="onSearchInput()"
            [disabled]="!canSearch() || searching"
            [loading]="searching"
            class="h-[50px]"
          />
        </p-inputgroup-addon>
      </p-inputgroup>
      <app-barcode-scanner
        (barcodeScanned)="handleBarcodeScanned($event)"
        class="ml-1"
      />
    </div>
  </div>

  <div class="px-3" *ngIf="showFilters">
    <div class="w-full max-w-5xl mx-auto bg-(--p-surface-0) border border-(--p-primary-200) rounded-md p-3">
      <div class="grid grid-cols-12 gap-2">
        <div class="col-span-12 sm:col-span-6 md:col-span-3">
          <p-iftalabel>
            <input id="name" class="w-full" pInputText [(ngModel)]="filters.name"
                   (ngModelChange)="onFilterChanged()"/>
            <label for="name">{{ 'dashboard.customSearch.filters.name' | transloco }}</label>
          </p-iftalabel>
        </div>
        <div class="col-span-12 md:col-span-3">
          <p-iftalabel>
            <input id="originsContact"
                   class="w-full"
                   pInputText
                   [(ngModel)]="filters.originsContact"
                   placeholder=""
                   (ngModelChange)="onFilterChanged()"/>
            <label for="originsContact">{{ 'dashboard.customSearch.filters.originsContact' | transloco }}</label>
          </p-iftalabel>
        </div>
        <div class="col-span-12 md:col-span-3">
          <p-iftalabel>
            <input id="whereaboutsContact"
                   class="w-full"
                   pInputText
                   [(ngModel)]="filters.whereaboutsContact"
                   placeholder=""
                   (ngModelChange)="onFilterChanged()"/>
            <label for="whereaboutsContact">{{ 'dashboard.customSearch.filters.whereaboutsContact' | transloco }}</label>
          </p-iftalabel>
        </div>
        <div class="col-span-12 md:col-span-3">
          <p-iftalabel>
            <input id="competentAuthority"
                   class="w-full"
                   pInputText
                   [(ngModel)]="filters.competentAuthority"
                   placeholder=""
                   (ngModelChange)="onFilterChanged()"/>
            <label for="competentAuthority">{{ 'dashboard.customSearch.filters.competentAuthority' | transloco }}</label>
          </p-iftalabel>
        </div>
        <div class="col-span-12 sm:col-span-6 md:col-span-3">
          <p-iftalabel>
            <p-select
              id="category"
              class="w-full"
              [options]="categoryOptions"
              [showClear]="true"
              [(ngModel)]="filters.category"
              optionLabel="name"
              optionValue="value"
              (ngModelChange)="onFilterChanged()"
            />
            <label for="category">{{ 'dashboard.customSearch.filters.category' | transloco }}</label>
          </p-iftalabel>
        </div>
        <div class="col-span-12 sm:col-span-6 md:col-span-3">
          <p-iftalabel>
            <p-select
              id="type"
              class="w-full"
              [options]="typeOptions"
              [showClear]="true"
              [(ngModel)]="filters.type"
              optionLabel="name"
              optionValue="value"
              (ngModelChange)="onFilterChanged()"
            />
            <label for="type">{{ 'dashboard.customSearch.filters.type' | transloco }}</label>
          </p-iftalabel>
        </div>
        <div class="col-span-12 sm:col-span-6 md:col-span-3">
          <p-iftalabel>
            <input id="bookNumber" class="w-full" pInputText [(ngModel)]="filters.oldBookNumber"
                   (ngModelChange)="onFilterChanged()"/>
            <label for="bookNumber">{{ 'dashboard.customSearch.filters.bookNumber' | transloco }}</label>
          </p-iftalabel>
        </div>
        <div class="col-span-12 sm:col-span-6 md:col-span-3">
          <p-iftalabel>
            <input id="petPassportNumber" class="w-full" pInputText [(ngModel)]="filters.petPassportNumber"
                   (ngModelChange)="onFilterChanged()"/>
            <label for="petPassportNumber">{{ 'dashboard.customSearch.filters.petPassportNumber' | transloco }}</label>
          </p-iftalabel>
        </div>

        <div class="col-span-12 sm:col-span-6 md:col-span-3">
          <p-iftalabel>
            <input id="equinePassportNumber" class="w-full" pInputText [(ngModel)]="filters.equinePassportNumber"
                   (ngModelChange)="onFilterChanged()"/>
            <label for="equinePassportNumber">{{ 'dashboard.customSearch.filters.equinePassportNumber' | transloco }}</label>
          </p-iftalabel>
        </div>
        <div class="col-span-12 sm:col-span-6 md:col-span-3">
          <p-iftalabel>
            <input id="lifeNumber" class="w-full" pInputText [(ngModel)]="filters.lifeNumber"
                   (ngModelChange)="onFilterChanged()"/>
            <label for="lifeNumber">{{ 'dashboard.customSearch.filters.lifeNumber' | transloco }}</label>
          </p-iftalabel>
        </div>
        <div class="col-span-12 sm:col-span-6 md:col-span-3">
          <p-iftalabel>
            <input id="transponderNumber" class="w-full" pInputText [(ngModel)]="filters.transponderNumber"
                   (ngModelChange)="onFilterChanged()"/>
            <label for="transponderNumber">{{ 'dashboard.customSearch.filters.transponderNumber' | transloco }}</label>
          </p-iftalabel>
        </div>
        <div class="col-span-12 sm:col-span-6 md:col-span-3">
          <p-iftalabel>
            <p-select
              id="sex"
              class="w-full"
              [options]="[
                { name: 'animal.sex.female' | transloco, value: 'female' },
                { name: 'animal.sex.male' | transloco, value: 'male' },
                { name: 'animal.sex.unknown' | transloco, value: 'unknown' }
              ]"
              [showClear]="true"
              [(ngModel)]="filters.sex"
              optionLabel="name"
              optionValue="value"
              (ngModelChange)="onFilterChanged()"
            />
            <label for="sex">{{ 'dashboard.customSearch.filters.sex' | transloco }}</label>
          </p-iftalabel>
        </div>

        <div class="col-span-12 sm:col-span-6 md:col-span-3">
          <p-iftalabel>
            <p-select
              id="coatType"
              class="w-full"
              [options]="coatTypeOptions"
              [filter]="true"
              [showClear]="true"
              [(ngModel)]="filters.coatType"
              optionLabel="name"
              optionValue="value"
              (ngModelChange)="onFilterChanged()"
            />
            <label for="coatType">{{ 'dashboard.customSearch.filters.coatType' | transloco }}</label>
          </p-iftalabel>
        </div>
        <div class="col-span-12 sm:col-span-6 md:col-span-3">
          <p-iftalabel>
            <input id="coatColor" class="w-full" pInputText [(ngModel)]="filters.coatColor"
                   (ngModelChange)="onFilterChanged()"/>
            <label for="coatColor">{{ 'dashboard.customSearch.filters.coatColor' | transloco }}</label>
          </p-iftalabel>
        </div>
        <div class="col-span-12 sm:col-span-6 md:col-span-3">
          <p-iftalabel>
            <input id="birthPlace" class="w-full" pInputText [(ngModel)]="filters.birthPlace"
                   (ngModelChange)="onFilterChanged()"/>
            <label for="birthPlace">{{ 'dashboard.customSearch.filters.birthPlace' | transloco }}</label>
          </p-iftalabel>
        </div>

        <div class="col-span-12 sm:col-span-6 md:col-span-3">
          <p-iftalabel>
            <input id="zipCode" class="w-full" pInputText [(ngModel)]="filters.zipCode"
                   (ngModelChange)="onFilterChanged()"/>
            <label for="zipCode">{{ 'dashboard.customSearch.filters.zipCode' | transloco }}</label>
          </p-iftalabel>
        </div>
        <div class="col-span-12 sm:col-span-6 md:col-span-3">
          <p-iftalabel>
            <p-select
              id="originType"
              class="w-full"
              [options]="originTypeOptions"
              [showClear]="true"
              [(ngModel)]="filters.originType"
              optionLabel="name"
              optionValue="value"
              (ngModelChange)="onFilterChanged()"
            />
            <label for="originType">{{ 'dashboard.customSearch.filters.origingType' | transloco }}</label>
          </p-iftalabel>
        </div>
        <div class="col-span-12 sm:col-span-6 md:col-span-3">
          <p-iftalabel>
            <p-select
              id="whereaboutType"
              class="w-full"
              [options]="whereaboutTypeOptions"
              [showClear]="true"
              [(ngModel)]="filters.whereaboutType"
              optionLabel="name"
              optionValue="value"
              (ngModelChange)="onFilterChanged()"
            />
            <label for="whereaboutType">{{ 'dashboard.customSearch.filters.whereaboutType' | transloco }}</label>
          </p-iftalabel>
        </div>

        <div class="col-span-12 md:col-span-6">
          <p-iftalabel>
            <div class="grid grid-cols-12 gap-2 items-center">
              <div class="col-span-6">
                <input
                  pInputText
                  id="weightMin"
                  class="w-full"
                  type="number"
                  min="0"
                  max="10"
                  step="0.1"
                  placeholder="{{ 'dashboard.customSearch.filters.min' | transloco }}"
                  [(ngModel)]="filters.weightMin"
                  (ngModelChange)="onFilterChanged()"
                />
              </div>
              <div class="col-span-6">
                <input
                  pInputText
                  id="weightMax"
                  class="w-full"
                  type="number"
                  min="0"
                  max="10"
                  step="0.1"
                  placeholder="{{ 'dashboard.customSearch.filters.max' | transloco }}"
                  [(ngModel)]="filters.weightMax"
                  (ngModelChange)="onFilterChanged()"
                />
              </div>
            </div>
            <label for="weightMin">{{ 'dashboard.customSearch.filters.weightRange' | transloco }}</label>
          </p-iftalabel>
        </div>
        <div class="col-span-12 md:col-span-6">
          <p-iftalabel>
            <div class="grid grid-cols-12 gap-2 items-center">
              <div class="col-span-6">
                <input
                  pInputText
                  id="sizeMin"
                  class="w-full"
                  type="number"
                  min="0"
                  max="10"
                  step="0.1"
                  placeholder="{{ 'dashboard.customSearch.filters.min' | transloco }}"
                  [(ngModel)]="filters.sizeMin"
                  (ngModelChange)="onFilterChanged()"
                />
              </div>
              <div class="col-span-6">
                <input
                  pInputText
                  id="sizeMax"
                  class="w-full"
                  type="number"
                  min="0"
                  max="10"
                  step="0.1"
                  placeholder="{{ 'dashboard.customSearch.filters.max' | transloco }}"
                  [(ngModel)]="filters.sizeMax"
                  (ngModelChange)="onFilterChanged()"
                />
              </div>
            </div>
            <label for="sizeMin">{{ 'dashboard.customSearch.filters.sizeRange' | transloco }}</label>
          </p-iftalabel>
        </div>
        <div class="col-span-12 md:col-span-6">
          <p-iftalabel>
            <div class="grid grid-cols-12 gap-2">
              <input id="birthdayStart" class="col-span-12 md:col-span-6" pInputText type="date" [(ngModel)]="filters.birthdayStart"
                   (ngModelChange)="onFilterChanged()"/>
              <input id="birthdayEnd" class="col-span-12 md:col-span-6" pInputText type="date" [(ngModel)]="filters.birthdayEnd"
                   (ngModelChange)="onFilterChanged()"/>
            </div>
            <label for="birthdayStart">{{ 'dashboard.customSearch.filters.birthdayRange' | transloco }}</label>
          </p-iftalabel>
        </div>
        <div class="col-span-12 md:col-span-6">
          <p-iftalabel>
            <div class="grid grid-cols-12 gap-2">
              <input id="dateOfReceiptStart" class="col-span-12 md:col-span-6" pInputText type="date" [(ngModel)]="filters.dateOfReceiptStart"
                     (ngModelChange)="onFilterChanged()"/>
              <input id="dateOfReceiptEnd" class="col-span-12 md:col-span-6" pInputText type="date" [(ngModel)]="filters.dateOfReceiptEnd"
                     (ngModelChange)="onFilterChanged()"/>
            </div>
            <label for="dateOfReceiptStart">{{ 'dashboard.customSearch.filters.dateOfReceipt' | transloco }}</label>
          </p-iftalabel>
        </div>
        <div class="col-span-12 flex justify-end gap-2 mt-2">
          <p-button [label]="'dashboard.customSearch.clearFilters' | transloco" (click)="clearFilters()" [text]="true" icon="pi pi-refresh"/>
          <p-button [label]="'dashboard.customSearch.applyFilters' | transloco" (click)="applyFilters()" icon="pi pi-check" [disabled]="!canSearch()"/>
        </div>
      </div>
    </div>
  </div>
  @if (!searching && searched && animalSearchResult.length === 0) {
    <div class="flex justify-center w-full">
    <div class="py-3 w-full max-w-xl">
      <div class="text-center mb-2">
        Keine Suchergebnisse gefunden. Neues Tier mit Startwert aufnehmen?
      </div>

      <p-inputgroup class="w-full">
        <p-select
          [options]="prefillOptions"
          optionLabel="label"
          optionValue="value"
          [(ngModel)]="prefillType"
          appendTo="body"
          class="w-full"
        ></p-select>

        <button
          type="button"
          pButton
          class="p-button-sm"
          icon="pi pi-angle-right"
          (click)="onStartAddAnimal()"
          pTooltip="Neues Tier anlegen"
          tooltipPosition="top"
        ></button>
      </p-inputgroup>
    </div>
  </div>
  }

  @if (searched && animalSearchResult.length > 0) {
    <app-animal-list-item
      [animals]="animalSearchResult"
      [pageable]="true"
      [pageSize]="pageSize"
      [first]="first"
      (pageChange)="onPageChange($event)"
    />
  }
</div>
